import type { PricingPlan } from 'Services/ProductManagement/Features/Product/types'
import {
  createContext,
  type Dispatch,
  type FC,
  type ReactNode,
  type SetStateAction,
  useMemo,
  useState
} from 'react'

interface TariffContextType {
  selectedTariffId: string
  setSelectedTariffId: Dispatch<SetStateAction<string>>
  copiedPricingPlans: PricingPlan[] | undefined
  setCopiedPricingPlans: Dispatch<SetStateAction<PricingPlan[] | undefined>>
}

const TariffContext = createContext<TariffContextType>({
  selectedTariffId: '',
  setSelectedTariffId: () => {},
  copiedPricingPlans: undefined,
  setCopiedPricingPlans: () => {}
})

interface TariffProviderProps {
  children: ReactNode
}

const TariffProvider: FC<TariffProviderProps> = ({ children }) => {
  const [selectedTariffId, setSelectedTariffId] = useState<string>('')
  const [copiedPricingPlans, setCopiedPricingPlans] = useState<PricingPlan[]>()

  const tariffProviderValues = useMemo(
    () => ({
      selectedTariffId,
      setSelectedTariffId,
      copiedPricingPlans,
      setCopiedPricingPlans
    }),
    [selectedTariffId, copiedPricingPlans]
  )

  return <TariffContext.Provider value={tariffProviderValues}>{children}</TariffContext.Provider>
}

export { TariffContext, TariffProvider }
